import { render, staticRenderFns } from "./pagePref.vue?vue&type=template&id=1d01f0ca&scoped=true"
import script from "./pagePref.vue?vue&type=script&lang=js"
export * from "./pagePref.vue?vue&type=script&lang=js"
import style0 from "./pagePref.vue?vue&type=style&index=0&id=1d01f0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d01f0ca",
  null
  
)

export default component.exports